/* eslint-disable */
import { createApp } from 'vue'
import App from './apps/FlashAlertApp.vue'

import TurbolinksAdapter from 'vue-turbolinks';

document.addEventListener('turbo:load', () => {
  const flashAlertsApp = createApp(App)
  flashAlertsApp.use(TurbolinksAdapter)
  flashAlertsApp.mount('#flash-alert-vue-target')
})
